import {Alert, Box, Button, CircularProgress, CssBaseline, Stack, TextField} from '@mui/material';
import * as React from 'react';
import Header from '@/components/Header';
import {useUserContext} from '@/components/Providers/UserContext';
import RentalsList from '@/components/RentalsList';
import useFetchRentals from '@/queries/useFetchRentals';
import {type MutateFunctionError} from '@/types/MutateFunctionError';
import {useEffect, useState} from "react";

const SupervisorAccess = () : React.ReactElement => {
    const {user} = useUserContext();
    const [rentalId, setRentalId] = useState('');
    const [rentalIdLocal, setRentalIdLocal] = useState('');
    const rentalsQuery = useFetchRentals(rentalId);
    const rentalsData = rentalsQuery.data?.data;
    const rentalsInfoMessage = rentalsQuery.data?.message;
    const rentalsInfoErrorCode = rentalsQuery.data?.errorCode;
    const rentalsQueryError = rentalsQuery.error as MutateFunctionError;

    useEffect(() => {
        if (rentalId !== '') {
            void rentalsQuery.refetch();
        }
    }, [rentalId]);

    return <React.Fragment>
        <CssBaseline/>
        <Header/>
        {!user?.isAdmin && <Stack
            sx={{
                flexGrow: 1,
                backgroundColor: '#631d79',
                height: '100%',
            }}
        >
            No Access
        </Stack>}
        {user?.isAdmin && <Stack
            sx={{
                flexGrow: 1,
                backgroundColor: '#631d79',
                height: '100%',
            }}
        >
            <Stack
                direction='column'
                justifyContent='flex-start'
                sx={{
                    backgroundColor: '#fff',
                    m: 2,
                    mt: '125px',
                    flexGrow: 1,
                    overflow: 'auto',
                }}
            >
                <Stack
                    direction='column'
                    justifyContent='flex-start'
                    sx={{
                        m: 2,
                        borderRadius: '8px',
                    }}
                >
                    <Box
                        sx={{
                            m: 3,
                            textAlign: 'center',
                        }}
                    >
                        <b>You are currently logged in as a supervisor.</b><br/>
                        To view another users rentals and history, enter their Staff Member ID and click "Fetch Rental Info".<br/>
                        To view your own records, click "Fetch Rental Info" with Staff Member ID empty.<br/>
                    </Box>
                    <Stack
                        sx={{
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'center',
                            width: '100%',
                            mb: 2,
                        }}
                    >
                        <TextField
                            name='rentalId'
                            size='small'
                            label={rentalIdLocal === '' ? 'Staff Member ID' : ''}
                            value={rentalIdLocal}
                            InputLabelProps={{shrink: false}}
                            onChange={(event) => {
                                setRentalIdLocal(event.target.value);
                            }}
                            sx={{
                                backgroundColor: '#fff',
                                borderRadius: '8px',
                            }}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                    event.preventDefault();
                                    setRentalIdLocal(rentalIdLocal);
                                    setRentalId(rentalIdLocal);
                                }
                            }}
                        />
                        <Stack justifyContent='center'>
                            <Button
                                variant='outlined'
                                size='small'
                                onClick={() => {
                                    setRentalId(rentalIdLocal);
                                }}
                                sx={{
                                    ml: 2,
                                    backgroundColor: '#fff',
                                }}
                            >
                                Fetch Rental Info
                            </Button>
                        </Stack>
                    </Stack>
                </Stack>

                {(rentalsQuery.isFetching || user === undefined) && rentalId !== '' && <Stack
                    direction='row'
                    justifyContent='center'
                    alignItems='center'
                    sx={{
                        height: '100%',
                    }}
                >
                    <CircularProgress/>
                </Stack>}

                {!rentalsQuery.isFetching && rentalId !== '' && <Stack
                    direction='row'
                    justifyContent='center'
                >
                    {rentalsInfoErrorCode === 0 && rentalsData?.rentals && rentalsData?.rentals.length === 0 && <Alert severity='error' sx={{my: 2}}>No Rentals Found</Alert>}
                    {rentalsQuery.isError && <Alert severity='error' sx={{my: 2}}>{rentalsQueryError.message}</Alert>}
                    {rentalsInfoErrorCode !== 0 && rentalsInfoMessage && <Alert severity='error' sx={{my: 2}}>{rentalsInfoMessage}</Alert>}
                </Stack>}

                {!rentalsQuery.isFetching && rentalId !== '' && rentalsData && rentalsData?.rentals.length > 0 && <Box sx={{width: '100%'}}>
                    <RentalsList
                        rentals={rentalsData?.rentals}
                        user={rentalsData?.user}
                    />
                </Box>}
            </Stack>
        </Stack>}
    </React.Fragment>;
};

export default SupervisorAccess;
